export default "__VITE_ASSET__6588cd17__"